// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1___94587fbb5ef7b507c46","cls2":"Reader-cls2___a088d0497e6fea9c397 Reader-cls1___94587fbb5ef7b507c46"};